import { axiosPrivate } from 'app/utils';

import helpers from '../helpers';
import serviceTemplateApi from './service-templates';

export default {
  async getOrganisationInviteLink({ chainId }) {
    const response = await axiosPrivate.post(`/tools/short-url`, {
      chain_id: chainId,
    });

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data;
  },
  async getOrganisationDeliverySubscriptionPlans(organisationId) {
    const response = await axiosPrivate.get(
      `/chains/${organisationId}/delivery-subscriptions?status=active`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data;
  },
  async getOrganisationDeliveryExemptionPlans(organisationId) {
    const response = await axiosPrivate.get(
      `/chains/${organisationId}/delivery-exemptions?status=active`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data;
  },
  async getOrganisationPaymentSettings(organisationId) {
    try {
      const response = await axiosPrivate.get(
        `/v3/pharmacist/organisations/${organisationId}/payment-settings`
      );

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },
  async getGroupServiceChargeOptions({ serviceTemplateId }) {
    try {
      const response = await axiosPrivate.get(
        `/v3/pharmacist/service-templates/${serviceTemplateId}/charge-options`
      );

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },
  async updateGroupServiceChargeOptions({ serviceTemplateId, payload }) {
    try {
      const response = await axiosPrivate.put(
        `/v3/pharmacist/service-templates/${serviceTemplateId}/charge-options`,
        payload
      );

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },
  async getOrganisationProducts(organisationId) {
    console.log('API: getOrganisationProducts called with organisationId:', organisationId);
    const response = await axiosPrivate.get(`/v3/organisations/${organisationId}/products`);
    console.log('API: getOrganisationProducts response:', response.data);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data;
  },

  async addOrganisationProduct(organisationId, productData) {
    const response = await axiosPrivate.post(
      `/v3/organisations/${organisationId}/products`,
      productData
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data;
  },

  async removeOrganisationProduct(organisationId, productId) {
    const response = await axiosPrivate.delete(
      `/v3/organisations/${organisationId}/products/${productId}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data;
  },

  async updateOrganisationProduct(organisationId, productId, productData) {
    const response = await axiosPrivate.put(
      `/v3/organisations/${organisationId}/products/${productId}`,
      productData
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data;
  },

  async getProductBranchesByOrganisation(organisationId, productId) {
    const response = await axiosPrivate.get(
      `/v3/organisations/${organisationId}/products/${productId}/branches`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async updateBranchProducts(organisationId, productId, branchProducts) {
    const response = await axiosPrivate.put(
      `/v3/organisations/${organisationId}/products/${productId}/branches`,
      { branchProducts }
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async requestUberEatsAccess(organisationId, message = '', pharmacyId = null) {
    const body = { message };
    if (pharmacyId) {
      body.pharmacyId = pharmacyId;
    }

    const response = await axiosPrivate.post(
      `/v3/organisations/${organisationId}/request-uber-eats-access`,
      body
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getOrganisationUberStoreStatus(organisationId) {
    try {
      const response = await axiosPrivate.get(
        `/v3/pharmacist/organisations/${organisationId}/uber-store-status`
      );

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      // Return default response for 404 errors (organisation not yet configured)
      if (error?.response?.status === 404) {
        return { status: null, organisationId };
      }
      throw error;
    }
  },

  async enableOrganisationUber(organisationId) {
    const response = await axiosPrivate.post(
      `/v3/pharmacist/organisations/${organisationId}/enable-uber`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getBlockOutRanges({ organisationId, page = 1 }) {
    const response = await axiosPrivate.get(
      `/v3/pharmacist/availability-block-out-ranges?organisationId=${organisationId}&page=${page}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getBlockOutRange({ blockOutRangeId }) {
    const response = await axiosPrivate.get(
      `/v3/pharmacist/availability-block-out-ranges/${blockOutRangeId}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async createBlockOutRange({ organisationId, startDate, endDate, branchIds, serviceTemplateIds, blockRefills, note }) {
    const response = await axiosPrivate.post('/v3/pharmacist/availability-block-out-ranges', {
      organisationId,
      startDate,
      endDate,
      branchIds,
      serviceTemplateIds,
      blockRefills,
      note,
    });

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async deleteBlockOutRange({ blockOutRangeId }) {
    const response = await axiosPrivate.delete(
      `/v3/pharmacist/availability-block-out-ranges/${blockOutRangeId}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getAppointmentsCount({ organisationId, branchId, startDate, endDate }) {
    const queryParams = new URLSearchParams({ startDate, endDate });
    if (branchId) queryParams.set('pharmacyId', branchId);
    if (!branchId) queryParams.set('organisationId', organisationId);

    const queryString = `?${queryParams.toString()}`;
    const response = await axiosPrivate.get(`/v3/pharmacist/appointments_counts${queryString}`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  ...serviceTemplateApi,
};
